import _React, { useContext } from 'react';
import { FormContext } from '../formContext';

export default () => {
  const formContext = useContext(FormContext);
  return [formContext];
};
